import React from "react";
import { euro } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

const Stat = ({ label, value, testId, accent }) => (
  <Card className="p-4" data-testid={testId}>
    <p className="text-xs uppercase tracking-wide text-muted-foreground">{label}</p>
    <p className={`font-head text-2xl font-bold mt-1 ${accent || ""}`}>{value}</p>
  </Card>
);

export const MarginTotals = ({ t }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-testid="margins-totals">
    <Stat label={`Venduto · ${t.orders} ordini`} value={euro(t.revenue)} testId="margins-total-revenue" />
    <Stat label="Costo alla fonte" value={euro(t.cost)} testId="margins-total-cost" />
    <Stat label="Quote rete" value={euro(t.shares)} testId="margins-total-shares" />
    <Stat label="Tuo margine" value={euro(t.margin)} testId="margins-total-margin" accent={t.margin >= 0 ? "text-teal-500" : "text-destructive"} />
    {(t.estimated > 0 || t.missing > 0) && <p className="col-span-2 lg:col-span-4 text-xs text-muted-foreground" data-testid="margins-total-note">{t.estimated} ordini con costo stimato · {t.missing} senza costo impostato (esclusi dal margine)</p>}
  </div>
);

export const MarginLadder = ({ row }) => (
  <div className="space-y-1 text-xs" data-testid={`margins-ladder-${row.id}`}>
    <div className="flex justify-between gap-4"><span>Incassato{row.vat_excluded ? " (IVA esclusa)" : ""}</span><span className="font-medium">{euro(row.revenue)}</span></div>
    <div className="flex justify-between gap-4"><span>Costo alla fonte {row.estimated && row.cost != null && <Badge variant="outline" className="ml-1 h-4 px-1 text-[10px]">stimato</Badge>}</span><span>{row.cost == null ? "non impostato" : `− ${euro(row.cost)}`}</span></div>
    {row.shares.map((s, i) => <div key={i} className="flex justify-between gap-4 text-muted-foreground"><span>{s.label}{s.name ? ` · ${s.name}` : ""}{s.kind !== "registrata" ? ` (${s.kind})` : ""}</span><span>− {euro(s.amount)}</span></div>)}
    {row.dealer_earning != null && <div className="flex justify-between gap-4 text-muted-foreground"><span>Ricarico del dealer sul cliente</span><span>{euro(row.dealer_earning)}</span></div>}
    <div className="flex justify-between gap-4 border-t border-border pt-1 font-semibold"><span>Resta a te</span><span className={row.admin_margin == null ? "" : row.admin_margin >= 0 ? "text-teal-500" : "text-destructive"}>{row.admin_margin == null ? "—" : euro(row.admin_margin)}</span></div>
  </div>
);

export const DealerRanking = ({ items }) => (
  <Card className="p-4 space-y-3" data-testid="margins-ranking">
    <h2 className="font-head font-semibold">Classifica dealer per margine</h2>
    {items.length === 0 && <p className="text-sm text-muted-foreground">Nessun ordine nel periodo.</p>}
    <ol className="space-y-2">
      {items.map((d, i) => (
        <li key={d.dealer_id || i} className="flex items-center gap-3 text-sm" data-testid={`margins-rank-${d.dealer_id}`}>
          <span className="w-6 text-muted-foreground font-mono">{i + 1}</span>
          <span className="flex-1 min-w-0 truncate">{d.dealer_name}{d.dealer_role === "master" && <Badge variant="outline" className="ml-2 text-[10px]">Master</Badge>}</span>
          <span className="text-xs text-muted-foreground hidden sm:inline">{d.orders} ord. · {euro(d.revenue)}</span>
          <span className={`font-semibold ${d.margin >= 0 ? "text-teal-500" : "text-destructive"}`}>{euro(d.margin)}</span>
        </li>
      ))}
    </ol>
  </Card>
);
